import React from 'react'

const Theme5Nophotocouple = ({values}) => {

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t5-preview-single-couple-container">

        <div className="t5-preview-couple-grandparents">
           {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t5-preview-couple-name">
          {fullname}
        </h1>

        <div className="t5-preview-couple-parents">
            {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
       fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });


  return (
     <div className="t5-couple-section t5-no-photo-couple">
         <div className="theme5-middle-preview-section-bg">
            <div className="theme5-preview-couple-card ">
             <div className="theme5-preview-nocouple-inner-content">
                     <h1 className="t5-preview-couple-heading" >
             {values?.sectionHeading}
          </h1>
             <div className="t5-couple-wrapper">
              {values.displayOrder==="groomFirst"?(
                          <>
                              {groomCard()}
                              <span className="t5-preview-couple-divider">
                        &
                    </span>
                            {brideCard()}
                          </>
                        ): (
                          <>
                              {brideCard()}
                                 <span className="t5-preview-couple-divider">
                        &
                    </span>
                    {groomCard()}
                          </>
                        )}
             </div>
             </div>
           
       
            </div>
         </div>
     </div>
  )
}

export default Theme5Nophotocouple